import type { UnlocodeEntry, Country } from '../types/vessel';

function toTitleCase(str: string): string {
  return str.replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.slice(1).toLowerCase());
}

function removeParenthetical(str: string): string {
  return str.replace(/\(.*?\)/g, '').trim();
}

export function translateDestination(
  rawLocode: string | undefined,
  unlocodeRegister: UnlocodeEntry[],
  countries: Country[]
): string {
  if (!rawLocode || typeof rawLocode !== 'string') return 'Unknown Destination';

  const normalizedRaw = rawLocode.trim();
  if (!normalizedRaw) return 'Unknown Destination';
  
  let countryCode = '';
  let portCode = '';

  if (normalizedRaw.includes('_')) {
    const parts = normalizedRaw.split('_').map((p) => p.trim());
    if (parts.length >= 2) {
      countryCode = parts[0].slice(0, 2).toUpperCase();
      portCode = parts[1].toUpperCase().slice(0, 3);
    }
  } else if (normalizedRaw.includes(' ')) {
    const parts = normalizedRaw.split(' ').map((p) => p.trim());
    if (parts.length >= 2) {
      countryCode = parts[0].toUpperCase();
      portCode = parts[1].toUpperCase().slice(0, 3);
    }
  } else {
    let code = normalizedRaw.toUpperCase().replace(/\s+/g, '').replace(/_/g, '');
    if (code.length > 5) code = code.slice(0, 5);
    countryCode = code.slice(0, 2);
    portCode = code.slice(2);
  }

  const entry = unlocodeRegister.find((e) => {
    const eCountry = typeof e.Country === 'string' ? e.Country.trim().toUpperCase() : '';
    const eLocation = typeof e.Location === 'string' ? e.Location.trim().toUpperCase() : '';
    return eCountry === countryCode && eLocation === portCode;
  });

  const countryMapping: Record<string, string> = {};
  countries.forEach((c) => {
    const code = c.CountryCode;
    const name = c.CountryName;
    if (code && name && typeof code === 'string' && typeof name === 'string') {
      countryMapping[code.trim().toUpperCase()] = removeParenthetical(name);
    }
  });

  const fullCountryName = countryMapping[countryCode] || countryCode;

  if (entry?.Name && typeof entry.Name === 'string') {
    return `${toTitleCase(entry.Name)}, ${toTitleCase(fullCountryName)}`;
  }

  return toTitleCase(normalizedRaw);
}
